export default __webpack_public_path__ + "static/media/lemontbotanique_l2.ab386042.png";